import { type ReactNode } from "react"
import { cn } from "../../lib/utils"

interface BadgeProps {
  variant?: "default" | "outline" | "success" | "warning" | "danger" | "info"
  className?: string
  children: ReactNode
}

export function Badge({ variant = "default", className, children }: BadgeProps) {
  const variants = {
    default: "bg-ink-100 dark:bg-ink-800 text-ink-800 dark:text-ink-200",
    outline: "border border-ink-300 dark:border-ink-700 text-ink-700 dark:text-ink-300",
    success: "bg-brand-100 dark:bg-brand-900/40 text-brand-800 dark:text-brand-300",
    warning: "bg-gold-100 dark:bg-gold-900/40 text-gold-800 dark:text-gold-300",
    danger: "bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300",
    info: "bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300",
  }
  return (
    <span className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold", variants[variant], className)}>
      {children}
    </span>
  )
}
